import { render, staticRenderFns } from "./refundDetails.vue?vue&type=template&id=fe24616c&scoped=true&"
import script from "./refundDetails.vue?vue&type=script&lang=js&"
export * from "./refundDetails.vue?vue&type=script&lang=js&"
import style0 from "./refundDetails.vue?vue&type=style&index=0&id=fe24616c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe24616c",
  null
  
)

export default component.exports